/**
 * Fixed skeleton chip width (px). Chosen as a representative chip
 * footprint matching the median of the production chip set so the
 * skeleton row maintains a stable visual rhythm without per-chip
 * layout shift when real data arrives.
 */
export const SKELETON_CHIP_WIDTH_PX = 180;

/**
 * Fixed skeleton chip height (px) mirroring the rendered border-box
 * height of `SuggestionChip`:
 *   2 * 0.5rem vertical padding (16px) +
 *   14px text * 1.6 line-height (22.4px) +
 *   2 * 1px border (2px) ≈ 40px.
 *
 * Hardcoded as a single number so the skeleton swap-in to the real
 * chip row introduces zero layout shift; if `SuggestionChip` padding
 * or typography changes, update this constant in lockstep.
 */
export const SKELETON_CHIP_HEIGHT_PX = 40;
